module.exports = __webpack_public_path__ + "img/confirm.9d0bc0db.png";